<template>
  <div class="pages opensource_container">
    <open-source-pro-android v-if="app === 'hsjpro' && platform === 'android'"/>
  </div>
</template>

<script>
import OpenSourceProAndroid from './hsjpro/android/OpenSource.vue';
export default {
  name: "OpenSource",
  components: {OpenSourceProAndroid},
  data() {
      return {
          app: 'hsj',
          platform: 'android'
      }
  },
  computed: {
  },
  watch: {
  },
  created() {
      this.app = this.$route.params?.app;
      this.platform = this.$route.params?.platform;
      console.log(this.$route);
      console.log('11', this.app, this.platform);
  },
};
</script>
